import ApiService from "../../utils/apiService";
import { toastr } from "react-redux-toastr";
import localization from "../../utils/localization";

export const Types = {
  GET_FILES_COUNT_START: "renewalProduction/getFilesCountStart",
  GET_FILES_COUNT_FULFILLED: "renewalProduction/getFilesCountFulFilled",
  GET_FILES_COUNT_REJECTED: "renewalProduction/getFilesCountRejected",
  GET_FILES_START: "renewalProduction/getFilesStart",
  GET_FILES_FULFILLED: "renewalProduction/getFilesFulfilled",
  GET_FILES_REJECTED: "renewalProduction/getFilesRejected",
  CREATE_FILE_START: "renewalProduction/createFileStart",
  CREATE_FILE_FULFILLED: "renewalProduction/createFileFulfilled",
  CREATE_FILE_REJECTED: "renewalProduction/createFileRejected",
  UPDATE_FILE_START: "renewalProduction/updateFileStart",
  UPDATE_FILE_FULFILLED: "renewalProduction/updateFileFulfilled",
  UPDATE_FILE_REJECTED: "renewalProduction/updateFileRejected",
  DELETE_FILE_START: "renewalProduction/deleteFileStart",
  DELETE_FILE_FULFILLED: "renewalProduction/deleteFileFulfilled",
  DELETE_FILE_REJECTED: "renewalProduction/deleteFileRejected",
};

export function getFilesCount(searchText = "") {
  return function (dispatch) {
    dispatch({ type: Types.GET_FILES_COUNT_START });

    ApiService.get(`renewal-production/count?q=${searchText}`)
      .then((response) => {
        dispatch({
          type: Types.GET_FILES_COUNT_FULFILLED,
          count: response.data.count,
        });
      })
      .catch((error) => {
        dispatch({
          type: Types.GET_FILES_COUNT_REJECTED,
          count: 0,
        });
      });
  };
}

export function getFiles(query = "", limit = null) {
  return function (dispatch) {
    dispatch({ type: Types.GET_FILES_START });

    var params = query;
    let limitParam =
      (params === "" ? "?" : "&") + "limit=" + (limit ? limit : 20);

    ApiService.get(`renewal-production${query}${limitParam}`)
      .then((response) => {
        dispatch({
          type: Types.GET_FILES_FULFILLED,
          files: response.data.files,
        });
      })
      .catch((error) => {
        dispatch({
          type: Types.GET_FILES_REJECTED,
          error: error,
        });

        if (error) {
          toastr.error(localization.toast.files.errorReading, error.message);
        }
      });
  };
}

export function createFile(file) {
  return function (dispatch) {
    dispatch({ type: Types.CREATE_FILE_START });

    ApiService.post("renewal-production", file)
      .then((response) => {
        dispatch({ type: Types.CREATE_FILE_FULFILLED });
        dispatch(getFiles());
        toastr.success(
          localization.toast.success,
          localization.toast.files.successCreated
        );
      })
      .catch((error) => {
        dispatch({ type: Types.CREATE_FILE_REJECTED, error: error });
        if (error) {
          if (error.response) {
            if (!error.response.data.success) {
              toastr.error(
                localization.toast.files.errorCreating,
                error.response.data.error
              );
            }
          } else {
            toastr.error(localization.toast.files.errorCreating, error.message);
          }
        }
      });
  };
}

export function updateFile(file) {
  return function (dispatch) {
    dispatch({ type: Types.UPDATE_FILE_START });

    ApiService.patch(`renewal-production/${file._id}`, file)
      .then((response) => {
        dispatch(getFiles());
        dispatch({ type: Types.UPDATE_FILE_FULFILLED });
        toastr.success(
          localization.toast.success,
          localization.toast.files.successUpdated
        );
      })
      .catch((error) => {
        dispatch({ type: Types.UPDATE_FILE_REJECTED, error: error });
        toastr.error(localization.toast.files.errorUpdating, error.message);
      });
  };
}

export function deleteFile(fileId) {
  return function (dispatch) {
    dispatch({ type: Types.DELETE_FILE_START });

    ApiService.delete(`renewal-production/${fileId}`)
      .then((response) => {
        dispatch(getFiles());
        dispatch({ type: Types.DELETE_FILE_FULFILLED });

        toastr.success(
          localization.toast.success,
          localization.toast.files.successRemoved
        );
      })
      .catch((error) => {
        dispatch({
          type: Types.DELETE_FILE_REJECTED,
          error: error,
        });

        toastr.error(localization.toast.files.errorRemoving, error.message);
      });
  };
}
